import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { TokenService } from "../services/token.service";
import { inject } from "@angular/core";
import { Observable } from "rxjs";

export const TokenInterceptorFn: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    let headers = req.headers;

    headers = headers.delete('Accept-Language');
    headers = headers.append('Accept-Language', 'pt-br');
    
    if(req.body !== null && typeof req.body !== 'string'){        
        headers = headers.append('Content-Type', 'application/json');
    }
    
    req = req.clone({
        headers: headers
    });

    if(req.url.includes('internal/authorization/v2/token') ||
       req.url.includes('tomas'))
        return next(req);
    
    const token = inject(TokenService).token;
    
    if (token) {
        req = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }    

    return next(req);
};